import { timezones } from '../../../../../../utilities/helpers'
import { TicketGroup } from './TicketGroup'
import { Countdown } from '../../../../components/Countdown'
import { GetSoldout } from '../../../../components/GetStatus/GetSoldout'
import { LoadingContainer } from '../../../../../LoadingContainer'
import useFiltersStore from '../../../../../../stores/filtersStore'

export default function ListingsContainer({
  isMappingCreated,
  isScheduled,
  scheduledTime,
  isLoadingTickets,
  quickpicks,
  soldout,
  reloadQuickPicks,
  needToUnlock,
}) {
  const event = useFiltersStore((state) => state.event)
  const timezone = timezones(event?.venue?.timezone)

  if (isLoadingTickets) {
    return <LoadingContainer />
  }

  if (!isMappingCreated) {
    return (
      <StateMessage
        title="Something went wrong!"
        description="Please try again in a few minutes."
      />
    )
  }

  if (isScheduled && scheduledTime) {
    return (
      <div className="spp-listings-body">
        <Countdown
          scheduledTime={scheduledTime}
          timezone={timezone}
          reloadQuickPicks={reloadQuickPicks}
        />
      </div>
    )
  }

  if (isScheduled && !scheduledTime) {
    return (
      <StateMessage
        title="Tickets are not on sale yet"
        description="Please check back later for on-sale availability."
      />
    )
  }

  if (soldout) {
    return (
      <div className="spp-listings-body spp-listings-body--center">
        <GetSoldout icon={true} fixedMobile={false} event={event} />
      </div>
    )
  }

  if (needToUnlock) {
    return (
      <StateMessage
        title="All available offers are locked..."
        description="Please try adjusting your filter preferences"
      />
    )
  }

  if (!quickpicks?.length) {
    return (
      <StateMessage
        title="No results for your filter"
        description="Please try adjusting your filter preferences"
      />
    )
  }

  return (
    <div className="spp-ticket-list">
      {quickpicks.map((pick, index) => (
        <TicketGroup
          key={`${pick.offer?.id ?? pick.id}-${pick.sectionId}-${pick.rowId || pick.rowNumber}-${index}`}
          pick={pick}
          venue={event?.venue}
        />
      ))}
    </div>
  )
}

function StateMessage({ title, description }) {
  return (
    <div className="spp-state-message">
      <p className="spp-state-message__title">{title}</p>
      <span className="spp-state-message__desc">{description}</span>
    </div>
  )
}
